import { Link } from "@/i18n/navigation";
import { Url } from "next/dist/shared/lib/router/router";
import React from "react";

const BlogLink = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href: Url;
}) => {
  return (
    <Link
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="gs--blog-link hover:text-primary font-bold transition-all"
    >
      {children}
    </Link>
  );
};

export default BlogLink;
